import React, { useCallback } from "react";
import { ClientSelector } from "../../../shared";
import { PayeeActionTypes, PayeeWorkflowModes } from "../../Context/constants";
import {
  usePayeeDispatchContext,
  useBasePayeeReducerContext,
  usePayeeWorkflowContext,
} from "../../Context/PayeeContext";

type ClientDetailsProps = { disabled?: boolean };

export const ClientDetails: React.FC<ClientDetailsProps> = ({ disabled }) => {
  const { mode } = usePayeeWorkflowContext();
  const dispatch = usePayeeDispatchContext();
  const { arenaName } = useBasePayeeReducerContext();

  const handleClientSelect = useCallback(
    (arenaId: string, arenaName: string) => {
      dispatch({
        type: PayeeActionTypes.SET_CLIENT_DETAILS_ARENA,
        payload: {
          arenaId,
          arenaName,
        },
      });
    },
    [dispatch],
  );

  return (
    <ClientSelector
      disabled={disabled || mode === PayeeWorkflowModes.EDIT}
      selectedArenaName={arenaName}
      onClientSelect={handleClientSelect}
      placeholder="Select a client for this payee"
      showErrorToast={true}
    />
  );
};
